import api from './api';
import ErrorService from './errorService';



export const rolService = {
  getAllRoles: async () => {
    try {
      const response = await ErrorService.withTimeout(api.get('/Rol'));
      return response.data;
  
    } catch (error) {
      ErrorService.handleApiError('Error al obtener roles:', error);
      throw error;
    }
  },

  getRoleById: async (id) => {
    try {
      const response = await ErrorService.withTimeout(api.get(`/Rol/${id}`));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError(`Error al obtener rol con id ${id}:`, error);
      throw error;
    }
  },

  createRole: async (roleData) => {
    try {
      const response = await ErrorService.withTimeout(api.post('/Rol', roleData));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al crear rol:', error);
      throw error;
    }
  },

  editRole: async (id, roleData) => {
    try {
      roleData.id = id;
      const response = await api.put(`/Rol/${id}`, roleData);
      return response.data;
    } catch (error) {
      console.error('Error al editar rol:', error);
      throw error;
    }
  },

  deactivateRole: async (id) => {
    try {
      const response = await api.delete(`/Rol/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al desactivar:', error);
      throw error;
    }
  },

};